import { create } from 'zustand';

interface SidebarState {
    isSidebarOpen: boolean;
    setIsSidebarOpen: (open: boolean) => void;
    toggleSidebar: () => void;
}

export const useSidebarStore = create<SidebarState>(set => ({
    isSidebarOpen: true,
    setIsSidebarOpen: (open: boolean) => set({ isSidebarOpen: open }),
    toggleSidebar: () => set(state => ({ isSidebarOpen: !state.isSidebarOpen })),
}));
